import { Placemark } from 'react-yandex-maps';
import { BalloonContent } from '@sharedComponents/BalloonContent';
import { useGetAbsoluteUrl } from '@hooks/useGetAbsoluteUrl';

export const PlacemarkBLock = ({ shop, isMobile, handleClickPlacemark }) => {
  const href = useGetAbsoluteUrl('/' + shop?.code);
  return (
    <Placemark
      onClick={() => handleClickPlacemark(shop)}
      modules={['geoObject.addon.balloon']}
      key={shop?.id}
      geometry={[shop?.map?.y, shop?.map?.x]}
      properties={{
        balloonContent: BalloonContent({ ...shop, code: href }, isMobile),
        clusterCaption: shop?.address,
      }}
      options={{
        iconLayout: 'default#image',
        iconImageHref: '/next/gimg/map/Placemark.svg',
        openBalloonOnClick: !isMobile,
        openEmptyBalloon: true,
        zIndex: 7077,
      }}
    />
  );
};
